import React from 'react';
import { AllocatableHistory } from '../AllocatableHistory';
import { CostCenterHistory } from '../CostCenterHistory';
import styles from './styles.module.scss';

interface HistoryResourceProps {
  resourceId?: string;
}

export const HistoryResource: React.FC<HistoryResourceProps> = ({ resourceId }) => {
  return (
    <div className={styles.historyContainer}>
      <AllocatableHistory resourceId={resourceId} />
      <CostCenterHistory resourceId={resourceId} />
    </div>
  );
};
